import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Components as DrawerComponents } from './Drawer.style';
import useOnClickOutside from 'use-onclickoutside';
const Drawer = _ref => {
  let {
    className = 'drawer',
    direction = 'left',
    open = false,
    zindex = 9999,
    children,
    onClose
  } = _ref;
  const drawerRef = React.useRef(null);
  const onClickOutsideHideOptions = event => {
    const target = event.target;
    const isDrawer = target.matches(".".concat(className));
    if (isDrawer) {
      onClose();
    }
  };
  useOnClickOutside(drawerRef, e => onClickOutsideHideOptions(e));
  return _jsx(_Fragment, {
    children: open && _jsx(DrawerComponents.Wrapper, _extends({
      className: className,
      zindex: zindex
    }, {
      children: _jsx(DrawerComponents.Drawer, _extends({
        className: "".concat(open ? 'open' : ''),
        ref: drawerRef,
        open: open,
        zindex: zindex,
        direction: direction
      }, {
        children: children
      }))
    }))
  });
};
export default Drawer;